/*
// import libraries
import axios from 'axios';
import Cookies from 'js-cookie'
import { useHistory } from 'react-router-dom';

// set env base url
// check if the url end with / or not
const ENV_URL = process.env.REACT_APP_BASE_URL;
const BASE_URL = ENV_URL.slice(-1) === '/' ? ENV_URL : ENV_URL + '/'

// `get` is the request method to be used when making the get request.
// Return a axios object with response you can use (then,catch ... ).
export const get = async (url,headers,isAuth=true) => {

    headers = header_data(isAuth,headers)
    return await axios.get(BASE_URL+url, { headers: headers })
}


// `post` is the request method to be used when making the post request.
// Return a axios object with response you can use (then,catch ... ).
export const post = async (url,headers,reqData,isAuth=true) => {

    headers = header_data(isAuth,headers)
    return await axios.post(BASE_URL+url, reqData, {
        headers: headers
    })

}


// `remove` is the request method to be used when making the delete request.
// Return a axios object with response you can use (then,catch ... ).
export const remove = async (url,headers) => {
    return await axios.delete(BASE_URL+url, {
        headers: headers
      });
}


// `put` is the request method to be used when making the put request.
// Return a axios object with response you can use (then,catch ... ).
export const put = async (url,headers,reqData) => {
    return await axios.put(BASE_URL+url, reqData, {
        headers: headers
      })
}

const header_data = (is_auth,hearder) =>{
    const AUTH_HEADER =  {'Authorization':Cookies.get("auth-token") ? 'Bearer '+Cookies.get("auth-token") : ''}
    if (is_auth)
        return Object.assign({},hearder,AUTH_HEADER)
    return hearder
}

*/

import axios from "axios";
import Cookies from "js-cookie";
import { logout, refresh } from "../apis/auth/auth";

// set env base url
// check if the url end with / or not
const ENV_URL = process.env.REACT_APP_BASE_URL;
const BASE_URL = ENV_URL.slice(-1) === "/" ? ENV_URL : ENV_URL + "/";

// Create an axios instance
const api = axios.create({
  baseURL: BASE_URL,
});
const isPublicPath = (path = "") => {
  return (
    path === "/login" ||
    path === "/iframe-map" ||
    path === "/iframe-map2" ||
    path.startsWith("/iframe-map/")
  );
};

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const authToken = Cookies.get("auth-token");
    config.headers.Source = `web`;
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor
let refreshPromise = null;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const prevRequest = error?.config;

    if (
      error?.response?.status === 401 &&
      prevRequest?.url === "api/check-token"
    ) {
      clearAuthData();
    }

    if (
      error?.response?.status === 401 &&
      !isPublicPath(window.location.pathname)
    ) {
      if (!prevRequest?.sent) {
        prevRequest.sent = true;

        // If no refresh in progress, start one
        if (!refreshPromise) {
          refreshPromise = refresh({
            refresh_token: Cookies.get("refresh-token"),
          })
            .then((res) => {
              const is_login = parseInt(res?.data?.isAuth);

              if (is_login === 1) {
                Cookies.set("auth-token", res?.data?.access_token);
                Cookies.set("refresh-token", res?.data?.refresh_token);
                Cookies.set("user-name", res?.data?.first_name);
                return res?.data?.access_token;
              } else {
                return Promise.reject(
                  new Error("Refresh token failed or expired"),
                );
              }
            })
            .finally(() => {
              refreshPromise = null;
            });
        }

        return refreshPromise
          .then((newAccessToken) => {
            prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
            return api(prevRequest); // retry original request
          })
          .catch((error) => {
            if (error.status === 401) {
              clearAuthData();
            }
            return Promise.reject(error);
          });
      }
    }

    return Promise.reject(error);
  },
);

const clearAuthData = () => {
  Cookies.remove("auth-token");
  Cookies.remove("refresh-token");
  localStorage.removeItem("user");
  window.location.href = "/login";
};

// Export functions using the axios instance
export const get = async (url, config = {}, isAuth = true) => {
  return await api.get(url, config);
};

export const post = async (url, config = {}, data, isAuth = true) => {
  return await api.post(url, data, config);
};

export const put = async (url, config = {}, data) => {
  return await api.put(url, data, config);
};

export const patch = async (url, config = {}, data) => {
  return await api.patch(url, data, config);
};

export const remove = async (url, config = {}) => {
  return await api.delete(url, config);
};
